import { XMLToJSON } from 'helpers/xmlToJson';
import { convertToObject } from 'utils/arrayConverted';


interface Cell {
    _: string;
}

interface Column {
    _: string;
    $: any;
}

 

interface Row {
    cell: Cell[];
}

interface Head {
    column: Column[];
}

interface DataConverted {
    rows: {
        head: Head[];
        row: Row[];
    };
}

export const getDataHeaders = async (data: string) => {
    try {
        const excludeFields = ['RECID'];
        const dataConverted: DataConverted = await XMLToJSON(data);
        // const dataHeaders = dataConverted.rows.head[0]?.column.map(item => item._).filter(header => !excludeFields.includes(header));
        const dataHeaders = dataConverted.rows.head[0]?.column.map(item => item._);
        return dataHeaders;

    } catch (error) {
        //console.warn('warning processing data:', error);
    }
} 

